import React from 'react'

import {LocationsTable} from "../../components/LocationsTable";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {BaseModal} from "../../components/BaseModal";


export const LocationModal = (props) => {
    const {
        customerLocation,
        dealerLocation,
        initialShouldChangeDealerToo,
        selectLocation,
        open,
        onClose,
        setIsOpen,
        isSaving,
        title,
        allowManualAdd,
        defaultLocation,
    } = props
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    const style = {
        position: 'absolute',
        top: '50%',
        minWidth: isTabletOrMobile ? '' : '760px',
        width: isTabletOrMobile ? '92%' : '760px',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        // The themed .LocationsTable card paints the surface (bg, border,
        // radius, shadow) so it tracks light/dark — keep this wrapper bare.
        background: 'transparent',
        zIndex: '1400',
        outline: 'none',
    };


    return (
        <BaseModal
            isOpen={open}
            onClose={onClose}
            setIsOpen={setIsOpen}
            style={style}
        >
            <LocationsTable
                customerLocation={customerLocation}
                dealerLocation={dealerLocation}
                initialShouldChangeDealerToo={initialShouldChangeDealerToo}
                selectLocation={selectLocation}
                isSaving={isSaving}
                allowManualAdd={allowManualAdd}
                defaultLocation={defaultLocation}
                // Same dismiss the backdrop and Escape use, so the header close
                // button cannot drift from them.
                onCloseModal={setIsOpen ? () => setIsOpen(null) : undefined}
                title={title}
            />
        </BaseModal>
    )
}